export default __webpack_public_path__ + "static/media/ri_arrow-bottom-s-line.7e936678.svg";